import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '@/layout/service/layout.service';
import { SentryExample } from '@/sentry-example.component';

@Component({
    selector: 'auth-layout',
    standalone: true,
    imports: [RouterModule, AppConfigurator, SentryExample],
    template: `
        <main>
            <router-outlet></router-outlet>
        </main>
        <!-- <button class="layout-config-button config-link" (click)="layoutService.toggleConfigSidebar()">
            <i class="pi pi-cog"></i>
        </button> -->
        <app-configurator location="landing" />
    `
})
export class AuthLayout {
    // <app-sentry-example></app-sentry-example>
    layoutService: LayoutService = inject(LayoutService);
}
